/**
 * 共通翻訳 - 日本語
 * Common translations - Japanese
 */

export default {
  language_switch: '言語切替',
  loading: '読み込み中...',
  error: 'エラー',
  success: '成功',
  confirm: '確認',
  cancel: 'キャンセル',
  close: '閉じる',
  save: '保存',
  edit: '編集',
  delete: '削除',
  search: '検索',
  submit: '送信',
  reset: 'リセット',
  back: '戻る',
  next: '次へ',
  previous: '前へ',
  more: 'もっと見る',
  less: '閉じる',
  all: 'すべて',
  viewDetails: '詳細を見る',
  learnMore: '詳しく見る',
  contactUs: 'お問い合わせ',
  readMore: '続きを読む',
  download: 'ダウンロード',
  comingSoon: '近日公開',
  clickToLocate: 'クリックして地図上で表示',
  mapOverview: 'マップ概要',
  regionContactCenter: '地域サービスセンター',
  serviceNodes: 'サービスセンター',
  serviceRegionsLabel: 'サービス地域',
  coverageCapability: 'カバレッジ',
  localSupport: 'ローカル対応',
  asiaPacificServiceNetwork: 'アジア太平洋サービスネットワーク',
  clickCardToLocate: '右側の地域カードをクリックすると、対応するサービスセンターへすばやく移動できます。',
  searchRegionPlaceholder: '地域 / 都市 / 住所を検索',
  zoomIn: '拡大',
  zoomOut: '縮小',
  resetView: 'リセット',
  staticMapPreview: '静的マップ表示',
  staticMapNote: 'この図はサービス提供範囲を示すためのもので、外部地図サービスには依存していません。',
  step: 'ステップ',
  standardizedDeliveryPath: '標準化された提供プロセス',
  serviceProcessIntro: '初期要件の整理から継続的な最適化まで、サービスプロセスを段階ごとに進めることで、各ステップの提供内容をより直感的に理解できます。',
  phase: 'フェーズ',
  openChat: 'チャットを開く',
  closeChat: 'チャットを閉じる',
  customerService: 'カスタマーサービス',
  send: '送信',
  invalidType: '種類を選択してください',
  invalidRegion: 'サービス地域を選択してください',
  invalidCompanyName: '会社名を入力してください',
  invalidContactName: '担当者名を入力してください',
  invalidPosition: '役職を入力してください',
  invalidEmail: 'メールアドレスを入力してください',
  invalidEmailFormat: '有効なメールアドレスを入力してください',
  invalidPhone: '電話番号を入力してください',
  invalidPhoneFormat: '有効な電話番号を入力してください',
  invalidIndustry: '業界を選択してください',
  invalidCompanySize: '会社規模を選択してください',
  invalidServices: '少なくとも1つの興味のあるサービスを選択してください',
  invalidMessage: 'プロジェクト要件を入力してください',
  requestFailed: 'リクエストに失敗しました',
  badRequest: 'リクエストパラメータが正しくありません',
  unauthorized: '認証されていません。再度ログインしてください。',
  forbidden: 'このリソースにアクセスする権限がありません。',
  notFound: '要求されたリソースが見つかりません。',
  serverError: 'サーバー内部エラー',
  badGateway: 'ゲートウェイエラー',
  serviceUnavailable: 'サービスは一時的に利用できません',
  requestFailedWithStatus: 'リクエストに失敗しました。ステータスコード: {status}',
  requestTimeout: 'リクエストがタイムアウトしました。しばらくしてから再度お試しください。',
  networkError: 'ネットワーク接続に失敗しました。接続状況をご確認ください。',
  submitFailedRetry: '送信に失敗しました。しばらくしてから再度お試しください。',
  submitFailedCheck: '入力内容が正しいかご確認ください。',
  submitFailedServer: 'サーバーが一時的にリクエストを処理できません。しばらくしてから再度お試しください。',
  submitFailedNetwork: 'ネットワーク接続に失敗しました。接続状況をご確認のうえ再度お試しください。',
  ticketList: {
    newTicket: '新規チケット',
    unassigned: '未割り当て',
    progressLabel: '進捗: {progress}%',
    status: {
      pending: '未対応',
      inProgress: '対応中',
      completed: '完了'
    },
    samples: {
      networkIssue: 'ネットワーク接続障害',
      softwareInstall: 'ソフトウェアインストールの問題',
      systemOptimization: 'システム性能最適化',
      supportA: '技術サポートA',
      supportB: '技術サポートB'
    }
  },
  share: '共有',
  copy: 'コピー',
  copied: 'コピーしました',
  required: '必須',
  optional: '任意',
  placeholder: '入力してください...'
}
